import React from 'react';
import * as RuiSwitch from '@radix-ui/react-switch';

import { createStyle } from 'utils/createStyle';
import { colors } from 'styles/settings';

export interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    offText?: string;
    onText?: string;
    isDisabled?: boolean;
}

const StyledSwitch = createStyle('rounded-full', {
    appearance: 'none',
    border: 'none',
    padding: 0,
    width: '60px',
    height: '25px',
    marginLeft: '2px',
    marginRight: '5px',
    backgroundColor: '#C4C4C4',
    verticalAlign: 'middle',
    // borderRadius: 25,
    position: 'relative',
    transitionDuration: '.4s',
    '&:focus': {
        outline: 'none',
        // boxShadow: '0 0 0 2px royalblue',
    },
    '&[data-state="checked"]': {
        color: 'white',
        backgroundColor: 'green',
    },
    '&[data-disabled]': {
        opacity: 0.6,
        cursor: 'default',
    },
});

const StyledThumb = createStyle('rounded-full', {
    top: 0,
    left: 0,
    transitionDuration: '.3s',
    position: 'absolute',
    transform: 'translate(5px, 4.5px)',
    margin: 0,
    padding: 0,
    height: '16px',
    width: '16px',
    background: 'white',
    boxShadow: '-1px 1px 1px rgba(147, 149, 152, 0.5)',
    border: '1px solid #ccddee',
    '&[data-state="checked"]': {
        transform: 'translate(37px, 4.5px)',
    },
    '&[data-disabled]': {
        backgroundColor: colors.grey2,
        border: `1px solid ${colors.grey2}`,
    },
});

export const SwitchWithText = ({
    checked,
    onChange,
    onText = 'ON',
    offText = 'OFF',
    isDisabled = false,
}: SwitchProps) => {
    return (
        <div style={{ display: 'flex' }}>
            <RuiSwitch.Root
                className={StyledSwitch}
                checked={checked}
                disabled={isDisabled}
                onCheckedChange={(e) => onChange(e.target.checked)}
            >
                {checked ? <span className="mr-4 text-sm font-bold">{onText}</span> : null}
                <RuiSwitch.Thumb className={StyledThumb} />
                {!checked ? <span className="ml-4 text-sm font-bold">{offText}</span> : null}
            </RuiSwitch.Root>
        </div>
    );
};
